import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HomeSelector } from '../reducers/HomeReducer';
import { PaymentSelector } from '../reducers/PaymentReducer';
import SignupPaymentAction from '../actions/SignupPaymentAction';
import ClickComponent from '../../components/clickPayment/ClickComponent';

const mapStateToProps = state => ({
  toAddress: HomeSelector.getSelectedAddressParts(state),
  contactNumber: PaymentSelector.getContactNumber(state),
  email: PaymentSelector.getEmail(state),
  clickErrorStatus: PaymentSelector.getClickErrorStatus(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    storeClickGatewayDetails: SignupPaymentAction.storeClickGatewayDetails,
    callback: SignupPaymentAction.submitSignup,
    updateClickErrorMessage: SignupPaymentAction.updateClickErrorMessage
  }, dispatch);

const ClickComponentContainer = connect(mapStateToProps, mapDispatchToProps)(ClickComponent);

export default ClickComponentContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ClickComponentContainer.js
 **/